var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.63241 7.50497C1.05402 7.08336 1.5532 6.87256 2.12996 6.87256C2.7056 6.87256 3.20421 7.08336 3.62582 7.50497L15.9789 19.8581L28.3742 7.46281C28.7677 7.06931 29.2596 6.87256 29.8498 6.87256C30.4401 6.87256 30.946 7.08336 31.3676 7.50497C31.7892 7.92658 32 8.42576 32 9.00252C32 9.57815 31.7892 10.0768 31.3676 10.4984L17.1594 24.6644C16.9908 24.833 16.8081 24.9528 16.6113 25.0236C16.4146 25.0933 16.2038 25.1282 15.9789 25.1282C15.7541 25.1282 15.5433 25.0933 15.3465 25.0236C15.1498 24.9528 14.9671 24.833 14.7984 24.6644L0.59025 10.4562C0.196751 10.0627 0 9.57815 0 9.00252C0 8.42576 0.210804 7.92658 0.63241 7.50497Z",
    fill: "#002466"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowDark);
export default __webpack_public_path__ + "static/media/downArrow_dark.0c60bad1e0930aa34f273b306cd2d859.svg";
export { ForwardRef as ReactComponent };